import React, { useState, useEffect, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckIcon from '@material-ui/icons/Check';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomAutocomplete from '../../components/CustomAutocomplete1';
import PhoneTextField from '../../components/PhoneTextField';
import EmailTextField from '../../components/EmailTextField';
import SaveIcon from '@material-ui/icons/Save';
import Dialog from '../../components/Dialog';
import {
  getRecipient,
  saveRecipient,
  updateRecipients,
  getFireHornSetting,
  getFireHornAssignAgencycounts,
  saveFireHornUser,
  sendTofireHornAPI,
  getPTSConnectSetting,
  getPTSAssignAgencycounts,
  savePTSConnectUser,
  sendToPTSConnectAPI,
} from '../../reducers/PagingReducer';
import { handleError } from '../../reducers/ErrorReducer';
import { closeEditPageRecipient } from '../../reducers/DialogsReducer';
import { showSpinner, hideSpinner } from '../../reducers/UiReducer';
import Dictionary from 'components/Dictionary';
import { Grid } from '@material-ui/core';
import PersonLookup2 from 'components/PersonLookup2';
import { notify } from '../../reducers/NotifierReducer';
import TextField2 from 'components/TextField2';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

function getFormStyle(minWidth, maxWidth) {
  return {
    maxWidth: maxWidth,
    flexBasis: minWidth,
    minWidth: minWidth,
    flexGrow: 1,
    margin: `0 4px 8px`,
  };
}

const useStyles = makeStyles(theme => ({
  container: {
    width: 800,
    minHeight: 450,
    maxWidth: '100%',
    margin: '0 auto',
  },
  form: {
    margin: `0 -${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  edit: {
    padding: theme.spacing(2),
    paddingBottom: 12,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    '& h4': {
      margin: '0.5em 0',
    },
  },
  textField: {
    margin: `0 ${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
  },
  w100x200: {
    ...getFormStyle(100, 200),
  },
  w100x150: {
    ...getFormStyle(100, 150),
  },
  w170x400: {
    ...getFormStyle(170, 400),
  },
  w200x300: {
    ...getFormStyle(200, 300),
  },
  w120x180: {
    ...getFormStyle(120, 180),
  },
  w250x180: {
    ...getFormStyle(250, 180),
  },
  w100pr: {
    width: '100%',
    margin: `0 4px 8px`,
  },
  requiredInfo: {
    fontSize: '0.75rem',
    marginBottom: 0,
  },
  addressFilter: {
    margin: `0 ${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
  },
  checkbox: {
    margin: `-${theme.spacing(0.5)}px ${theme.spacing(0.5)}px 0`,
  },
  actions: {
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  actions2: {
    '& button': {
      marginLeft: theme.spacing(1),
      opacity: 0,
      transition: 'opacity 0.3s',
    },
  },
  row: {
    '&:hover': {
      '& button': {
        opacity: 1,
      },
    },
  },
}));

const headCells = [
  { id: 'ContactMethod', numeric: false, disablePadding: false, label: 'Contact Method' },
  { id: 'MethodType', numeric: false, disablePadding: false, label: 'Method Type' },
  { id: 'Info', numeric: false, disablePadding: false, label: 'Info' },
];

const contactMethods = ['Email', 'Phone'];

function ContactTableHead(props) {
  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? 'none' : 'default'}>
            {headCell.label}
          </TableCell>
        ))}
        <TableCell align="center">Default</TableCell>
        <TableCell align="center">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
}

function RecipientEdit(props) {
  const classes = useStyles();
  const { dictionary, ptsRecipientID, recipients } = props;
  const [data, setData] = useState(null);
  const [edited, setEdited] = useState(false);
  const [Recipient, setRecipient] = useState('');
  const [ptsPersonID, setPtsPersonID] = useState(null);
  const [IsDisabled, setIsDisabled] = useState(null);
  const [ContactInfo, setContactInfo] = useState([]);
  const [ContactMethod, setContactMethod] = useState(null);
  const [MethodType, setMethodType] = useState(null);
  const [PhoneNo, setPhoneNo] = useState('');
  const [PhoneNoValid, setPhoneNoValid] = useState();
  const [Email, setEmail] = useState('');
  const [EmailValid, setEmailValid] = useState(false);
  const [secretCode, setSecretCode] = useState(null);
  const [secretCodeError, setSecretCodeError] = useState('');
  const [showSecretCode, setShowSecretCode] = useState(false);
  const [IsDefault, setIsDefault] = useState(true);
  const [editedIndex, setEditedIndex] = useState(-1);
  const [editedValid, setEditedValid] = useState(false);
  const [valid, setValid] = useState(false);
  const [disableDefault, setDisableDefault] = useState(false);
  const [cellularCarrier, setCellularCarrier] = useState(null);
  const [mergedValue, setMergedValue] = useState('');
  const [IsFireHorn, setIsFireHorn] = useState(false);
  const [fireHornSetting, setFireHornSetting] = useState([]);
  const [fireHornAssignAgencycounts, setFireHornAssignAgencycounts] = useState([]);
  const [fireHornUserId, setFireHornUserId] = useState('');
  const [IsPTSConnect, setIsPTSConnect] = useState(false);
  const [ptsConnectSetting, setPtsConnectSetting] = useState([]);
  const [ptsConnectAssignAgencycounts, setPtsConnectAssignAgencycounts] = useState([]);
  const [Agency, setAgency] = useState('');
  const [currentAgency, setCurrentAgency] = useState('');
  const [agencyError, setagencyError] = useState('');
  const [userError, setuserError] = useState('');

  const fetchedSecretCode = useRef(false);
  const existingSecretCode = useRef(null);

  const agencies = useSelector(state => state.dictionary.Agencies);
  useEffect(() => {
    async function fetchSettings() {
      const settings = await getFireHornSetting();
      setFireHornSetting(settings);
      const count = getFireHornAssignAgencycounts(recipients);
      setFireHornAssignAgencycounts(count);
    }
    async function fetchPTSSettings() {
      const settings = await getPTSConnectSetting();
      setPtsConnectSetting(settings);
      const count = getPTSAssignAgencycounts(recipients);
      setPtsConnectAssignAgencycounts(count);
    }
    fetchSettings();
    fetchPTSSettings();

  }, []);

  const getPhoneNumbers = () => {
    return ContactInfo
      .filter(contact => {
        const info = contact.Info;
        if (!info) return false;
        
        const digits = info.replace(/\D/g, '');
        return digits.length === 10;
      })
      .map(contact => contact.Info);
  };

  const fetchSecretCode = async () => {
    const phoneNumbers = getPhoneNumbers();
    const bodyData = {
      phone_numbers: phoneNumbers,
      agency: '',
    };
    const data = await sendToPTSConnectAPI('POST', 'user/secret-code', bodyData);
    setSecretCode(data?.members?.[0]?.secret_code || '');
    existingSecretCode.current = data?.members?.[0]?.secret_code || '';
    fetchedSecretCode.current = true;
  };

  useEffect(() => {
    if (ContactInfo?.length > 0 && IsPTSConnect && !fetchedSecretCode.current) fetchSecretCode();
  }, [ContactInfo, IsPTSConnect]);

  const fireHornAgencies = agencies
    ?.filter(agency =>
      fireHornSetting.some(
        s => s.agency?.toLowerCase() === agency.AgencyID?.toLowerCase() && s.enable
      )
    )
    ?.map(a => {
      const key = a.AgencyID?.toLowerCase();
      const setting = fireHornSetting.find(s => s.agency?.toLowerCase() === key);
      const used = fireHornAssignAgencycounts[key] || 0;
      const allowed = setting?.noofrecipient || 0;
      return { ...a, count: allowed - used };
    });
  
  const ptsConnectAgencies = agencies
    ?.filter(agency =>
      ptsConnectSetting.some(
        s => s.agency?.toLowerCase() === agency.AgencyID?.toLowerCase() && s.enable
      )
    )
    ?.map(a => {
      const key = a.AgencyID?.toLowerCase();
      const setting = ptsConnectSetting.find(s => s.agency?.toLowerCase() === key);
      const used = ptsConnectAssignAgencycounts[key] || 0;
      const allowed = setting?.noofrecipient || 0;
      return { ...a, count: allowed - used };
    });  

  const getAgencyOptions = () => {
    if (IsFireHorn && IsPTSConnect) {
      const ptsSet = new Set(ptsConnectAgencies.map(a => a.AgencyID));
      return fireHornAgencies.filter(a => ptsSet.has(a.AgencyID));
    }
    return IsFireHorn ? fireHornAgencies : IsPTSConnect ? ptsConnectAgencies : [];
  };

  useEffect(() => {
    if (ptsRecipientID && ptsRecipientID !== true) {
      loadRecipient();
    } else {
      setRecipient('');
      setIsDisabled(false);
      setIsFireHorn(false);
      setIsPTSConnect(false);
      setAgency('');
      setCurrentAgency('');
      setContactInfo([]);
      setFireHornUserId('');
    }
    // eslint-disable-next-line
  }, [ptsRecipientID]);
  useEffect(() => {
    if (!data) return;
    const currentAgency = (agencies || []).find(agn => agn.AgencyID === data.AgencyId);
    setRecipient(data.Recipient);
    setPtsPersonID(data.ptsPersonID);
    setIsDisabled(data.IsDisabled);
    setContactInfo(data.ContactInfo);
    setAgency(currentAgency);
    setCurrentAgency(currentAgency);
    setIsFireHorn(data.IsFireHorn ?? false);
    setFireHornUserId(data.FireHornUserId);
    setIsPTSConnect(data.IsPTSConnect ?? false);
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    validateContact();
    // eslint-disable-next-line
  }, [Email, PhoneNo, MethodType, ContactMethod, IsDefault]);

  useEffect(() => {
    validate();
    setagencyError('');
    setuserError('');    
    if (IsFireHorn || IsPTSConnect) {
      if (!Agency) return setagencyError('Please select agency'), setValid(false);
      if (!ptsPersonID) return setuserError('Please select person'), setValid(false);
    }
    const agencyId = Agency?.AgencyID?.toLowerCase();
    const currentId = currentAgency?.AgencyID?.toLowerCase();
    if (IsFireHorn && agencyId && agencyId !== currentId) {
      const setting = fireHornSetting.find(s => s.agency?.toLowerCase() === agencyId);
      const used = recipients.filter(r => r.IsFireHorn && r.AgencyId?.toLowerCase() === agencyId)
        .length;
      const allowed = setting?.noofrecipient || 0;
      if (allowed - used <= 0) {
        setagencyError(`FireHorn limit exceeded for ${Agency?.AgencyID}`);
        setValid(false);
        return;
      }
    }
    if (IsPTSConnect && agencyId && agencyId !== currentId) {
      const setting = ptsConnectSetting.find(s => s.agency?.toLowerCase() === agencyId);
      const used = recipients.filter(r => r.IsPTSConnect && r.AgencyId?.toLowerCase() === agencyId)
        .length;
      const allowed = setting?.noofrecipient || 0;
      if (allowed - used <= 0) {
        setagencyError(`PTS limit exceeded for ${Agency?.AgencyID}`);
        setValid(false);
        return;
      }
    }
  }, [ContactInfo, Recipient, IsDisabled, ptsPersonID, IsFireHorn, IsPTSConnect, Agency]);

  useEffect(() => {
    if (!ContactMethod || !edited) return;
    const Info = ContactInfo.filter(i => i.ContactMethod === ContactMethod);
    let isDefault;
    if (editedIndex !== -1) {
      const contact = ContactInfo[editedIndex];
      isDefault = contact.IsDefault && contact.ContactMethod === ContactMethod;
    } else {
      isDefault = false;
    }
    const defaultExists = Info.reduce((r, c) => (c.IsDefault ? true : r), false);
    let disableDefault = defaultExists;
    if (isDefault) disableDefault = false;
    setDisableDefault(disableDefault);
    if (disableDefault) setIsDefault(false);
    // eslint-disable-next-line
  }, [ContactMethod, edited]);

  const validate = () => {
    (Boolean(Recipient) !== valid && setValid(Boolean(Recipient))) ||
      ((IsFireHorn || IsPTSConnect) && !Agency && setValid(false));
  };

  const loadRecipient = () => {
    props.showSpinner();
    getRecipient(ptsRecipientID)
      .then(result => setData(result))
      .catch(err => props.handleError(err, 'Error, Recipient data not loaded.'))
      .finally(() => props.hideSpinner());
  };

  const validateContact = () => {
    let valid = true;
    if (!ContactMethod) valid = false;
    if (!MethodType) valid = false;
    if (ContactMethod === 'Email' && !EmailValid) valid = false;
    if (ContactMethod === 'Phone' && !PhoneNoValid) valid = false;
    if (editedValid !== valid) setEditedValid(valid);
  };

  const handlePersonChange = person => {
    if (person) {
      setRecipient(person.FullName);
      setPtsPersonID(person.ptsPersonID);
      if (ptsRecipientID === true) {
        setContactInfo(person.ContactInfo);
      }
    } else {
      setRecipient('');
      setPtsPersonID(null);
      if (ptsRecipientID === true) {
        setContactInfo([]);
      }
    }
  };

  const renderRecipientForm = () => {
    return (
      <div className={classes.form}>
        <PersonLookup2
          className={classes.w100pr}
          onPersonChange={handlePersonChange}
          disabled={edited}
          ptsPersonID={ptsPersonID}
          error={!!userError}
          helperText={userError}
        />
        <FormControlLabel
          className={clsx(classes.checkbox, classes.w100x150)}
          style={{ marginTop: 5 }}
          control={
            <Checkbox
              checked={!IsDisabled}
              onChange={ev => setIsDisabled(!IsDisabled)}
              className={classes.checkbox}
            />
          }
          label="Active"
          disabled={edited}
        />
        <FormControlLabel
          className={clsx(classes.checkbox, classes.w100x150)}
          style={{ marginTop: 5 }}
          control={
            <Checkbox
              checked={IsFireHorn}
              onChange={ev => setIsFireHorn(!IsFireHorn)}
              className={classes.checkbox}
            />
          }
          label="FireHorn"
          disabled={edited}
        />
        <FormControlLabel
          className={clsx(classes.checkbox, classes.w100x150)}
          style={{ marginTop: 5 }}
          control={
            <Checkbox
              checked={IsPTSConnect}
              onChange={ev => setIsPTSConnect(!IsPTSConnect)}
              className={classes.checkbox}
            />
          }
          label="Vocal"
          disabled={edited}
        />
        {(IsFireHorn || IsPTSConnect) && (
          <Box style={{ marginLeft: 10, width: 300 }}>
            <Autocomplete
              options={getAgencyOptions()}
              className={classes.item}
              onChange={(e, val) => setAgency(val)}
              value={Agency}
              getOptionLabel={option => option.AgencyID}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Select Agency"
                  variant="outlined"
                  error={!!agencyError}
                  helperText={agencyError}
                />
              )}
              renderOption={option => {
                const base = `${option.AgencyID} ${option.Description ? '- ' + option.Description : ''}`;
                return IsFireHorn && IsPTSConnect ? base : `${base} (${option.count})`;
              }}
              size="small"
              fullWidth
            />
          </Box>
        )}
        {IsPTSConnect && (
          <>
            <Box style={{ margin: 10, width: 300, display: 'flex', flexDirection: 'column' }}>
              <TextField2
                style={{ marginBottom: 10 }}
                label="Secret Code"
                value={secretCode}
                error={secretCodeError}
                onChange={(ev, val) => {
                  setSecretCode(val);
                  setSecretCodeError('');
                }}
                type={showSecretCode ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={showSecretCode ? 'Hide secret code' : 'Show secret code'}
                        onClick={() => setShowSecretCode(show => !show)}
                        onMouseDown={event => event.preventDefault()}
                        edge="end">
                        {showSecretCode ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </>
        )}
      </div>
    );
  };

  const editContact = idx => {
    const contact = ContactInfo[idx];
    setContactMethod(contact.ContactMethod);
    setMethodType(contact.MethodType);
    setIsDefault(contact.IsDefault);
    setEdited(true);
    setEditedIndex(idx);
    if (contact.ContactMethod === 'Email') {
      setEmail(contact.Info);
      setPhoneNo('');
    } else {
      setEmail('');
      setPhoneNo(contact.Info);
    }
  };

  const deleteContact = idx => {
    if (window.confirm('Are you sure you want to delete the contact this method?')) {
      const newContactInfo = [...ContactInfo];
      newContactInfo.splice(idx, 1);
      setContactInfo(newContactInfo);
    }
  };

  const closeEditContact = () => {
    setEdited(false);
  };

  const addContact = () => {
    const IsDefault = ContactInfo.reduce((res, c) => (c.IsDefault ? false : res), true);
    setEdited(true);
    setContactMethod(null);
    setMethodType(null);
    setEmail('');
    setPhoneNo('');
    setEditedIndex(-1);
    setIsDefault(IsDefault);
  };

  const saveContact = () => {
    if (editedIndex === -1) {
      const newContact = {
        ContactMethod,
        MethodType,
        Info: ContactMethod === 'Email' ? Email : PhoneNo,
        IsDefault: IsDefault,
      };
      setContactInfo([...ContactInfo, newContact]);
    } else {
      const newContact = ContactInfo[editedIndex];
      newContact.ContactMethod = ContactMethod;
      newContact.MethodType = MethodType;
      newContact.Info = ContactMethod === 'Email' ? Email : PhoneNo;
      newContact.IsDefault = IsDefault;
      const newContactInfo = [...ContactInfo];
      newContactInfo.splice(editedIndex, 1, newContact);
      setContactInfo(newContactInfo);
    }
    closeEditContact();
  };

  const save = () => {
    if (IsPTSConnect) {
      if (!/^\d{6}$/.test(secretCode || '')) {
        const message = 'Secret Code must contain exactly 6 digits.';
        setSecretCodeError(message);
        props.notify(message, 'error');
        return;
      }
      setSecretCodeError('');

      const hasEmail = ContactInfo.some(
        contact => contact.ContactMethod === 'Email' && contact.IsDefault && contact.Info?.trim()
      );
      const hasPhone = ContactInfo.some(
        contact => contact.ContactMethod === 'Phone' && contact.Info?.trim()
      );
      if (!hasEmail || !hasPhone) {
        props.notify('Vocal requires at least default email and one phone number.', 'error');
        return;
      }
    }

    props.showSpinner();
    const setting = fireHornSetting.find(
      s => s.agency?.toLowerCase() === Agency?.AgencyID?.toLowerCase()
    );
    const fireHornAgencyId = setting?.agencyId;
    const currentFireHornAgenctId = fireHornSetting.find(
      s => s.agency?.toLowerCase() === currentAgency?.AgencyID?.toLowerCase()
    )?.agencyId;
    if (IsFireHorn && Agency?.AgencyID && Agency.AgencyID !== currentAgency?.AgencyID) {
      const used = recipients.filter(
        r => r.IsFireHorn && r.AgencyId?.toLowerCase() === Agency?.AgencyID?.toLowerCase()
      ).length;
      const allowed = setting?.noofrecipient || 0;
      if (allowed - used <= 0) {
        props.notify(`FireHorn recipient limit exceeded for agency ${Agency?.AgencyID}.`, 'error');
        props.hideSpinner();
        return;
      }
    }
    var AgencyId = (IsFireHorn || IsPTSConnect) ? Agency?.AgencyID : '';
    const Info = ContactInfo.filter(i => i.ContactMethod === 'Phone');
    const defaultEmail = ContactInfo.find(i => i.ContactMethod === 'Email' && i.IsDefault);
    const recipient = {
      IsDisabled,
      IsFireHorn,
      AgencyId,
      ContactInfo,
      ptsPersonID,
      Recipient,
      ptsRecipientID: ptsRecipientID !== true ? ptsRecipientID : null,
      IsPTSConnect : IsPTSConnect,
    };
    saveRecipient(recipient)
      .then(async savedReceipt => {
        recipient.ptsRecipientID = savedReceipt
          ? savedReceipt.ptsRecipientID
          : recipient.ptsRecipientID;
        if (
          (fireHornAgencyId && !IsFireHorn && currentAgency) ||
          (fireHornUserId && currentAgency && Agency.AgencyID !== currentAgency.AgencyID)
        ) {
          await sendTofireHornAPI(
            'DELETE',
            `users/${fireHornUserId}/agencies/${currentFireHornAgenctId}/`,
            null
          );
        }
        if (fireHornAgencyId && IsFireHorn) {
          await saveFireHornUser(fireHornAgencyId, recipient, fireHornUserId, Info);
        }
        if (IsPTSConnect && Agency?.AgencyID) {
          const response = await savePTSConnectUser(Agency?.AgencyID,recipient,Info, defaultEmail?.Info);
          if (existingSecretCode.current !== secretCode) {
            await sendToPTSConnectAPI('POST', `members/by-phone/reset-code`, {
              code: secretCode,
              email: defaultEmail?.Info,
              phone_numbers: Info.map(i => i.Info),
            });
          }
        }
        if (!IsPTSConnect && currentAgency?.AgencyID) {
          await sendToPTSConnectAPI('POST', 'user/delete', {
            member_code: String(recipient.ptsPersonID)
          });
        }
        props.updateRecipients();
        props.closeEditPageRecipient();
      })
      .catch(err => props.handleError(err, 'Unable to save recipient data'))
      .finally(() => props.hideSpinner());
  };

  const renderContactTable = () => {
    return (
      <>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" size="small">
            <ContactTableHead classes={classes} rowCount={ContactInfo.length} />
            <TableBody>
              {ContactInfo.map((row, index) => {
                return (
                  <TableRow hover key={index} className={classes.row}>
                    <TableCell align="left">{row.ContactMethod}</TableCell>
                    <TableCell align="center">{row.MethodType}</TableCell>
                    <TableCell align="left">{row.Info}</TableCell>
                    <TableCell align="center">{row.IsDefault ? <CheckIcon /> : null}</TableCell>
                    <TableCell align="right" className={classes.actions2}>
                      <IconButton onClick={() => editContact(index)} disabled={edited}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton onClick={() => deleteContact(index)} disabled={edited}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };

  const renderActionHeader = () => {
    return (
      <div className={classes.header}>
        <h4>Recipients</h4>
        <div className={classes.actions}>
          {!edited && (
            <Fab size="small" color="secondary" onClick={addContact}>
              <AddIcon />
            </Fab>
          )}
          {edited && (
            <Fab size="small" color="secondary" onClick={closeEditContact}>
              <CloseIcon />
            </Fab>
          )}
          {edited && (
            <Fab size="small" color="secondary" onClick={saveContact} disabled={!editedValid}>
              <SaveIcon />
            </Fab>
          )}
        </div>
      </div>
    );
  };

  const renderEditContactForm = () => {
    const handleAddCellularData = () => {
      if (ContactMethod === 'Email') {
        setMergedValue(Email?.split('@')[0] + cellularCarrier.Code);
      } else {
        setMergedValue(PhoneNo?.split('@')[0] + cellularCarrier.Code);
      }
    };
    return (
      <div className={classes.form}>
        <Autocomplete
          options={contactMethods}
          value={ContactMethod}
          onChange={(event, newValue) => setContactMethod(newValue)}
          className={classes.w170x400}
          renderInput={params => (
            <TextField {...params} label="Contact Method*" variant="outlined" />
          )}
          size="small"
        />

        <CustomAutocomplete
          label="Method Type*"
          options={dictionary.ContactMethodTypes}
          value={MethodType}
          onChange={newValue => setMethodType(newValue)}
          className={classes.w170x400}
          size="small"
        />
        <Grid container spacing={2}>
          {ContactMethod === 'Phone' && (
            <Grid item xs={6}>
              <PhoneTextField
                label="Phone*"
                className={classes.w100pr}
                variant="outlined"
                mergedValue={mergedValue}
                size="small"
                onChange={val => setPhoneNo(val)}
                value={PhoneNo}
                isValid={isValid => isValid !== PhoneNoValid && setPhoneNoValid(isValid)}
                short
              />
            </Grid>
          )}

          {ContactMethod === 'Email' && (
            <Grid item xs={6}>
              <EmailTextField
                label="Email*"
                className={classes.w100pr}
                variant="outlined"
                size="small"
                onChange={val => setEmail(val)}
                value={Email}
                mergedValue={mergedValue}
                isValid={isValid => isValid !== EmailValid && setEmailValid(isValid)}
              />
            </Grid>
          )}
          {ContactMethod && (
            <>
              <Grid item xs={1}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={
                    !cellularCarrier ||
                    (ContactMethod === 'Email' && !Email) ||
                    (ContactMethod === 'Phone' && !PhoneNo)
                  }
                  onClick={handleAddCellularData}>
                  Add
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Dictionary
                  options="CellularCarrier"
                  className={classes.item}
                  onChange={(ev, val) => setCellularCarrier(val)}
                  value={cellularCarrier}
                  label="Cellular Carrier"
                />
              </Grid>
            </>
          )}
        </Grid>
        {Boolean(ContactMethod) && (
          <FormControlLabel
            className={clsx(classes.checkbox, classes.w120x180)}
            control={
              <Checkbox
                checked={IsDefault}
                onChange={ev => setIsDefault(!IsDefault)}
                className={classes.checkbox}
                disabled={disableDefault}
              />
            }
            label="Default"
          />
        )}
      </div>
    );
  };

  const renderActions = () => {
    return (
      <div className={classes.actions}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={save}
          disabled={!valid || edited}>
          <SaveIcon /> Save
        </Button>
        <Button onClick={props.closeEditPageRecipient} color="primary" size="small">
          <CloseIcon /> Close
        </Button>
      </div>
    );
  };

  return (
    <Dialog
      open={true}
      onClose={props.closeEditPageRecipient}
      title={ptsRecipientID && ptsRecipientID !== true ? `Edit Recipient - ${Recipient ?? ''}` : 'Add Recipient'}
      actions={renderActions()}
      toolbar>
      <div className={classes.container}>
        {renderRecipientForm()}
        {renderActionHeader()}
        {edited && renderEditContactForm()}
        {renderContactTable()}
      </div>
    </Dialog>
  );
}

const mapStateToProps = state => {
  return {
    dictionary: state.dictionary,
  };
};

export default connect(mapStateToProps, {
  updateRecipients,
  showSpinner,
  hideSpinner,
  closeEditPageRecipient,
  handleError,
  notify,
})(RecipientEdit);
